import React, { useState, useEffect, useCallback } from 'react';
import { TextField, Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const AddressDetailsForm = ({
  apartmentNumber: initialApartment,
  setApartmentNumber,
  floor: initialFloor,
  setFloor,
  buildingName: initialBuilding,
  setBuildingName,
  accessCode: initialAccessCode,
  setAccessCode,
  instructions: initialInstructions,
  setInstructions,
  isPickup = false,
}) => {
  const { t } = useTranslation();

  const [apartmentNumber, setLocalApartment]     = useState(initialApartment     ?? '');
  const [floor,           setLocalFloor]         = useState(initialFloor         ?? '');
  const [buildingName,    setLocalBuilding]       = useState(initialBuilding      ?? '');
  const [accessCode,      setLocalAccessCode]     = useState(initialAccessCode    ?? '');
  const [instructions,    setLocalInstructions]   = useState(initialInstructions  ?? '');

  useEffect(() => { setLocalApartment(initialApartment      ?? ''); }, [initialApartment]);
  useEffect(() => { setLocalFloor(initialFloor              ?? ''); }, [initialFloor]);
  useEffect(() => { setLocalBuilding(initialBuilding        ?? ''); }, [initialBuilding]);
  useEffect(() => { setLocalAccessCode(initialAccessCode    ?? ''); }, [initialAccessCode]);
  useEffect(() => { setLocalInstructions(initialInstructions ?? ''); }, [initialInstructions]);

  const handleApartmentBlur    = useCallback(() => setApartmentNumber?.(apartmentNumber), [setApartmentNumber, apartmentNumber]);
  const handleFloorBlur        = useCallback(() => setFloor?.(floor),                     [setFloor,           floor]);
  const handleBuildingBlur     = useCallback(() => setBuildingName?.(buildingName),        [setBuildingName,    buildingName]);
  const handleAccessCodeBlur   = useCallback(() => setAccessCode?.(accessCode),            [setAccessCode,      accessCode]);
  const handleInstructionsBlur = useCallback(() => setInstructions?.(instructions),        [setInstructions,    instructions]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <TextField
          fullWidth size="small" multiline rows={4}
          label={isPickup
            ? t('delivery.form.pickupInstructions', 'Pickup Instructions')
            : t('delivery.form.deliveryInstructions', 'Delivery Instructions')}
          placeholder={isPickup
            ? t('delivery.form.pickupInstructionsPlaceholder', 'e.g., "Ring doorbell twice..."')
            : t('delivery.form.deliveryInstructionsPlaceholder', 'e.g., "Leave at door..."')}
          value={instructions}
          onChange={(e) => setLocalInstructions(e.target.value)}
          onBlur={handleInstructionsBlur}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          fullWidth size="small"
          label={t('delivery.form.apartmentNumber', 'Apt/Unit')}
          placeholder={t('delivery.form.apartmentPlaceholder', '12B')}
          value={apartmentNumber}
          onChange={(e) => setLocalApartment(e.target.value)}
          onBlur={handleApartmentBlur}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth size="small"
          label={t('delivery.form.floor', 'Floor')}
          placeholder={t('delivery.form.floorPlaceholder', '3')}
          value={floor}
          onChange={(e) => setLocalFloor(e.target.value)}
          onBlur={handleFloorBlur}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          fullWidth size="small"
          label={t('delivery.form.buildingName', 'Building')}
          placeholder={t('delivery.form.buildingPlaceholder', 'Building A')}
          value={buildingName}
          onChange={(e) => setLocalBuilding(e.target.value)}
          onBlur={handleBuildingBlur}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth size="small"
          label={t('delivery.form.accessCode', 'Access Code')}
          placeholder={t('delivery.form.accessCodePlaceholder', '#1234*')}
          value={accessCode}
          onChange={(e) => setLocalAccessCode(e.target.value)}
          onBlur={handleAccessCodeBlur}
        />
      </Grid>
    </Grid>
  );
};